import { render, staticRenderFns } from "./StatusDot.vue?vue&type=template&id=36af985b&scoped=true"
import script from "./StatusDot.vue?vue&type=script&lang=ts"
export * from "./StatusDot.vue?vue&type=script&lang=ts"
import style0 from "./StatusDot.vue?vue&type=style&index=0&id=36af985b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36af985b",
  null
  
)

export default component.exports